var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMobilEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-5);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3-7);\n      }\n\n      .cls-4 {\n        fill: url(#GradientFill_3-6);\n      }\n\n      .cls-5 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-6 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-7 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 49.96,
    x2: 25,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    y1: 49.96,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-4",
    "data-name": "GradientFill 3",
    x1: 14.69,
    y1: 49.96,
    x2: 14.69,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-5",
    "data-name": "GradientFill 3",
    x1: 14.69,
    y1: 49.96,
    x2: 14.69,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-6",
    "data-name": "GradientFill 3",
    x1: 35.31,
    y1: 49.96,
    x2: 35.31,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-7",
    "data-name": "GradientFill 3",
    x1: 35.31,
    y1: 49.96,
    x2: 35.31,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25,0C11.22,0,0,11.21,0,25s11.22,25,25,25,25-11.21,25-25S38.78,0,25,0ZM25,46.94c-12.1,0-21.94-9.84-21.94-21.94S12.9,3.06,25,3.06s21.94,9.84,21.94,21.94-9.84,21.94-21.94,21.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.19,25.59c.25-.36.25-.83,0-1.18-.22-.31-5.44-7.66-12.19-7.66s-11.97,7.34-12.19,7.66c-.25.36-.25.83,0,1.18.22.31,5.44,7.66,12.19,7.66s11.97-7.34,12.19-7.66ZM25,31.19c-4.66,0-8.72-4.54-10.04-6.19,1.32-1.65,5.38-6.19,10.04-6.19s8.72,4.53,10.05,6.19c-1.32,1.65-5.38,6.19-10.05,6.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25,20.88c-2.27,0-4.12,1.85-4.12,4.12s1.85,4.12,4.12,4.12,4.12-1.85,4.12-4.12-1.85-4.12-4.12-4.12ZM25,27.06c-1.14,0-2.06-.92-2.06-2.06s.93-2.06,2.06-2.06,2.06.92,2.06,2.06-.93,2.06-2.06,2.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.59,18.81c.57,0,1.03-.46,1.03-1.03v-5.16h5.16c.57,0,1.03-.46,1.03-1.03s-.46-1.03-1.03-1.03h-6.19c-.57,0-1.03.46-1.03,1.03v6.19c0,.57.46,1.03,1.03,1.03Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.78,37.37h-5.16v-5.16c0-.57-.46-1.03-1.03-1.03s-1.03.46-1.03,1.03v6.19c0,.57.46,1.03,1.03,1.03h6.19c.57,0,1.03-.46,1.03-1.03s-.46-1.03-1.03-1.03Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.4,31.19c-.57,0-1.03.46-1.03,1.03v5.16h-5.16c-.57,0-1.03.46-1.03,1.03s.46,1.03,1.03,1.03h6.19c.57,0,1.03-.46,1.03-1.03v-6.19c0-.57-.46-1.03-1.03-1.03Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.4,10.56h-6.19c-.57,0-1.03.46-1.03,1.03s.46,1.03,1.03,1.03h5.16v5.16c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-6.19c0-.57-.46-1.03-1.03-1.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobilEye);
export default __webpack_public_path__ + "static/media/Icon_MobilEye.87fe0fb944441cf9354378df459fcfbb.svg";
export { ForwardRef as ReactComponent };